export const login = {
  hi: '¡Qué bueno volverte a ver!',
  email: 'E-mail',
  password: 'Contraseña',
  logIn: 'Entrar',
  iForgotMyPassword: 'Olvidé mi contraseña',
  iDontHaveAnAccount: '¿Eres nuevo por aquí?',
  signUpNow: 'Registrate ahora',
  or: 'O ingresa tus datos',
  loginWithFacebook: 'Continúa con Facebook',
}



// WEBPACK FOOTER //
// ./src/sections/login/text.js